import { Component, input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent {
  /**
   * The variant/type of alert
   * - 'info': Yellow informational banner (center-aligned)
   * - 'warning': Red alert banner with icon (left-aligned)
   */
  variant = input<'info' | 'warning'>('info');

  /**
   * Primary message content
   */
  message = input<string>('');

  /**
   * Secondary message (only for warning variant)
   * Displayed in smaller, italic text
   */
  secondaryMessage = input<string | undefined>(undefined);

  /**
   * Bootstrap icon class (defaults to exclamation-circle for warning variant)
   */
  iconClass = input<string>('bi-exclamation-circle');
}
